export const TEXTS = {
  PRIME_TITLE: 'По подписке СберБизнес Прайм',
  PRIME_POINT_COUNT: 'Один адрес',
  PRIME_PRICE: '₽ в месяц',
  PRIME_HINT:
    'Специальная цена доступна для новых пользователей Звук Бизнес. Для текущих клиентов с действующей подпиской оплата по специальной цене доступна со следующего расчетного периода.',
  PRIME_HINT_OFFER_LINK: 'Ознакомиться с условиями акции',
};
